import type { StudioFoto } from '../types/business'

export const fotosStudio: StudioFoto[] = [
  {
    id: 'recepcao',
    legenda: 'Recepção reservada e silenciosa',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/24780175-61d0-452c-b266-8a9a08685667.jpg',
    alt: 'Recepção da clínica com balcão ripado, plantas e parede de travertino',
  },
  {
    id: 'sala-quiropraxia',
    legenda: 'Sala de quiropraxia com maca articulada',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/1d66e7b0-b8d1-44f5-bd7b-3641fa5dbb5f.jpg',
    alt: 'Atendimento de quiropraxia em maca com lençóis creme',
  },
  {
    id: 'sala-seitai',
    legenda: 'Espaço de Seitai no futon',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/82667373-da55-4835-bb2a-4d8f1cdf92fb.jpg',
    alt: 'Sessão de Seitai em futon de algodão em sala minimalista',
  },
  {
    id: 'nutricao',
    legenda: 'Bancada de orientação alimentar',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/17bb5295-8272-466d-8cfa-a82faedadb78.jpg',
    alt: 'Fermentados, folhas verdes e exames sobre bancada de travertino',
  },
  {
    id: 'avaliacao',
    legenda: 'Avaliação de composição corporal',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/9661d83c-e622-412c-9252-b9efbb342b62.jpg',
    alt: 'Balança de bioimpedância, fita métrica e caderno de metas',
  },
]
